import { TextField } from "@mui/material";
import { useField } from "formik"; // Leverage Formik's field handling
import PTFormInput from "./PTFormInput";
import { translate } from "../../utils/translate";
import { getGridNumericQuickFilterFn } from "@mui/x-data-grid";
import PTTranslate from "./PTTranslate";
import i18next from "i18next";

/* TODO: ADD 
import PropTypes from 'prop-types';

// Prop type validation
PTCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  isHidden: PropTypes.bool,
  xs: PropTypes.number,
  md: PropTypes.number,
  gridOptions: PropTypes.object,
};*/

const getTranslationString = (element) => {
  return i18next.t(element.props.tk);
};

export const PTTextInput = ({
  name,
  label,
  type,
  required,
  isHidden,
  xs = 12,
  md = 4,
  lg = 3,
  gridOptions,
  hiddenLabel,
  tooltip,
  multiline = false,
  placeHolder,
  height = 40,
  rows = 1,
  isDisabled = (inputName)=> false,
  error,
  ...props
}) => {
  const disabled = isDisabled(name)
  const { formName } = props;
  if (!formName) throw new Error("le Form parent is required for TextInput");
  const [field, meta] = useField(name);

  return (
    <PTFormInput
      isHidden={isHidden}
      label={label}
      name={name}
      required={required}
      tooltip={tooltip}
      hiddenLabel={hiddenLabel}
      md={md}
      xs={xs}
      lg={lg}
      {...gridOptions}
    >
      <TextField
        {...field}
        fullWidth
        variant="outlined"
        multiline={multiline}
        type={type}
        placeholder={getTranslationString(<PTTranslate tk={placeHolder} />)}
        error={meta.touched && !!meta.error}
        helperText={meta.touched && translate(meta.error)}
        required={required}
        disabled={disabled}
        InputLabelProps={{ shrink: true }}
        InputProps={{
          sx: {
            alignItems: multiline ? 'flex-start' : 'center',
            height: multiline
              ? `${Math.max(height, Math.min(80, rows * height))}px`
              : `${height}px`,
            backgroundColor: disabled ? "#e0e0e0" : "#FFFFFF",
            borderColor: error ? "red" : "inherit",
            "& .MuiOutlinedInput-input": {
              boxSizing: "border-box",
              "&:-webkit-autofill": {
                height: "100%",
              },
            },
          },
        }}
        {...props}
      />
    </PTFormInput>
  );
};

export default PTTextInput;
